'use client';

import { PropsWithChildren, useMemo, useState } from 'react';
import { Component } from '@headless-workspace/typings';
import { ProductDetailContext, ProductDetailContextType } from './ProductDetailContext';

type ProductDetailProviderProps = {
    productSku?: string;
} & PropsWithChildren;

export const ProductDetailProvider: Component<ProductDetailProviderProps> = ({ children, productSku }) => {
    const [sku, setSku] = useState(productSku);

    const productDetailStateProviderValue = useMemo<ProductDetailContextType>(
        () => ({
            sku: sku ?? '',
            setSku,
        }),
        [sku, setSku],
    );

    return (
        <ProductDetailContext.Provider value={productDetailStateProviderValue}>
            {children}
        </ProductDetailContext.Provider>
    );
};
